export const ExpireCacheServiceModule = angular
    .module('app.services.utilities.expireCache', [])
    .service('expireCache', ($http) => {
        return (res) => {
            return $http.post(process.env.EXPIRE_CACHE_URL)
                .then(() => res)
                .catch(() => res);
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/utilities/expireCache.service.js